export class ReportModel {
    predjenoKilometara = 0;
    noviObjekti = 0;
    novihStalaka = 0;
    uvecanjeStalaka = 0;
    umanjenjeStalaka = 0;
    zamenaStalaka = 0;
    isporuka = 0;
    ukupnoPoseta = 0;
    promocija = 0;
    totalVisits = 0;
    activeDays = 0;
    monthlyReportForUsers = [];
    ukupnoAktivnostiSaStalcima = 0;
    prosecnoAktivnostiPoMerchandiseru = 0;
    prosecnoAktivnostiPoMerchandiseruDnevno = 0;
    prosecanBrojPosetaPoMerchandiseru = 0;
    prosecanBrojPosetaPoMerchandiseruDnevno = 0;
    prosecanBrojKilometaraPoMerchandiseru = 0;
    prosecanBrojKilometaraPoMerchandiseruDnevno = 0;
    prosecanBrojRadnihDana = 0;
    grade = 0;
}